export default __webpack_public_path__ + "static/RTG_PDP_LOGO_SFC_290x100-63cd5a27085d99cb0060bce89d3715cb.png";